var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.feeConfiguration)?_c('div',[_c('Details',{attrs:{"feeConfiguration":_vm.feeConfiguration},on:{"feeConfigUpdated":_vm.handleFeeConfigUpdate}}),_c('FeeRanges',{attrs:{"feeConfiguration":_vm.feeConfiguration,"url":_vm.url}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }